import React from 'react';

import { css } from 'styled-components';
import Box from '../Box/Box';
import { Head3, Head4, Body1 } from '../Typography/Typography';

const IEBanner = () => {
    return (
        <Box
            bg="primary.main"
            position="fixed"
            top="0"
            left="0"
            right="0"
            bottom="0"
            display="flex"
            alignItems="center"
            justifyContent="center"
            flexDirection="column"
            css={css`
                * {
                    margin-bottom: 1rem;
                }
            `}
        >
            <Head3 light>#meetingsreinvented</Head3>
            <Head3 light>adam.ai currently supports these browsers</Head3>
            <Head4 light>
                Chrome 65+, Firefox 59+, Safari 11+, and Edge 42+.
            </Head4>
            <Head4 light>More browsers coming soon.</Head4>
            <Body1 light>
                Contact us at{' '}
                <a href="mailto:support@adam.ai">support@adam.ai</a>
            </Body1>
        </Box>
    );
};

export default IEBanner;
